import { GARAGE_PANEL_LOCATION, BASEMENT_PANEL_LOCATION } from '../constants/';

const electricPanelLocations = [
  {id: GARAGE_PANEL_LOCATION, value: 'Garage', title: 'Garage', upfrontCost: 0},
  {id: BASEMENT_PANEL_LOCATION, value: 'Basement', title: 'Basement', upfrontCost: 293},
];

export default electricPanelLocations;
